import { createCanvas } from './loadImage';

export function applyMask(screenCanvas: HTMLCanvasElement, maskImage: CanvasImageSource): void {
  const width = screenCanvas.width;
  const height = screenCanvas.height;

  const screenCtx = screenCanvas.getContext('2d');
  if (!screenCtx) {
    throw new Error('2D context is not available for screen canvas');
  }

  const maskCanvas = createCanvas(width, height);
  const maskCtx = maskCanvas.getContext('2d');
  if (!maskCtx) {
    throw new Error('2D context is not available for mask canvas');
  }

  maskCtx.clearRect(0, 0, width, height);
  maskCtx.drawImage(maskImage, 0, 0, width, height);

  const screenData = screenCtx.getImageData(0, 0, width, height);
  const maskData = maskCtx.getImageData(0, 0, width, height);

  for (let index = 0; index < screenData.data.length; index += 4) {
    const maskR = maskData.data[index];
    const maskG = maskData.data[index + 1];
    const maskB = maskData.data[index + 2];
    const maskA = maskData.data[index + 3] / 255;

    // Black/white mask: white keeps, black cuts. Use luminance as alpha factor.
    const luminance = (maskR + maskG + maskB) / (255 * 3);
    const factor = luminance * maskA;

    screenData.data[index + 3] = Math.round(screenData.data[index + 3] * factor);
  }

  screenCtx.putImageData(screenData, 0, 0);
}
